<template>
    <div>
        <v-form
            ref="reset_pass"
            v-model="valid_reset_pass"
        >  

            <div class="max-w-[550px] mx-auto my-2">
                <registration-title :title="$t('Ripristina password')">
                    <template v-slot:outer-slot>
                        <p class="text-center">
                            {{$t('ripristina_pass_text')}}
                        </p>
                    </template>
                </registration-title>
                <b v-if="mail_sent" class="text-green">{{$t('mail_inviata_correttamente')}}</b>
                <div>
                    <v-text-field
                    :rules="disable_rules ? [] : [validation_rules.required, validation_rules.email]"
                    :label="$t('E-mail')"
                    outlined
                    dense
                    v-model="email_for_reset"
                    ></v-text-field>
                    <div class="grid grid-cols-1 gap-[.5rem] divide-y divide-grey">
                    <div class="pb-[1rem]">
                        <v-btn color="primary" dark block @click="resetPass()">{{$t('Reset')}}</v-btn>
                    </div>
                    <div class="flex justify-start pt-[.5rem]">
                        <small><a class="block text-center" @click="routerTarget()">{{$t('Torna al login')}}</a></small>
                        <!-- <small><a class="block text-center" @click="tab = 'login'">{{$t('Torna al login')}}</a></small> -->
                    </div>
                    
                    </div>
                </div>
            </div>

        </v-form>
    </div>
</template>

<script>
export default {
    name: "ThePassword",
    data() {
        return {
            mail_sent: false,
            disable_rules: true,
            valid_reset_pass: true,
            email_for_reset: "",
        };
    },
    methods: {
        routerTarget(){
            let main_path = this.$route.meta.from == 'agency' ? '' : '-models'
            this.$router.replace({ path: `/login${main_path}` });
        },
        async resetPass() {
         this.disable_rules =  false
         await this.delay(200)
         let valid = await this.$refs.reset_pass.validate();
         if(valid){
            let response = await this.$store.dispatch("resetPass",this.email_for_reset);

            if(response.response.message == "EMAIL_SENT") 
               this.mail_sent = true

            this.disable_rules = true
         }
      },
    },
}
</script>

<style lang="scss" scope>
/*  */
</style>